import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-line-chart-with-table',
  templateUrl: './line-chart-with-table.component.html',
  styleUrls: ['./line-chart-with-table.component.css']
})
export class LineChartWithTableComponent {


    // lineChart

    @Input() public lineChartData: Array<any> = [
      {data: [-65, 59, 80, -81, 56, 55, 40], label: 'Series A'},
      {data: [28, 48, 40, 19, 86, -27, 90], label: 'Series B'},
      {data: [18, 48, 77, -9, 100, 27, 40], label: 'Series C'}
    ];
    @Input() public lineChartLabels: Array<any> = ['January', 'February', 'March', 'April', 'May', 'June', 'July'];
    public lineChartOptions: any = {
      responsive: true
    };
    public lineChartColors: Array<any> = [
      { // grey
        backgroundColor: 'rgba(148,159,177,0.2)',
        borderColor: 'rgba(148,159,177,1)',
        pointBackgroundColor: 'rgba(148,159,177,1)',
        pointBorderColor: '#fff',
        pointHoverBackgroundColor: '#fff',
        pointHoverBorderColor: 'rgba(148,159,177,0.8)'
      },
      { // dark grey
        backgroundColor: 'rgba(77,83,96,0.2)',
        borderColor: 'rgba(77,83,96,1)',
        pointBackgroundColor: 'rgba(77,83,96,1)',
        pointBorderColor: '#fff',
        pointHoverBackgroundColor: '#fff',
        pointHoverBorderColor: 'rgba(77,83,96,1)'
      },
      { // grey
        backgroundColor: 'rgba(148,159,177,0.2)',
        borderColor: 'rgba(148,159,177,1)',
        pointBackgroundColor: 'rgba(148,159,177,1)',
        pointBorderColor: '#fff',
        pointHoverBackgroundColor: '#fff',
        pointHoverBorderColor: 'rgba(148,159,177,0.8)'
      }
    ];
    public lineChartLegend = true;
    public lineChartType = 'line';

  constructor() { }


}



// WEBPACK FOOTER //
// ./src/app/report/charts/line-chart-with-table/line-chart-with-table.component.ts